// extracted by mini-css-extract-plugin
export default {"icon":"FormInput-module--icon--UrOqL","clear-button":"FormInput-module--clear-button--Obgez"};